import { DetailedHTMLProps, FC, HTMLAttributes } from "react";
import { Box, SxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

type HTMLImageTypes = DetailedHTMLProps<
  HTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>;
interface ImageProps extends HTMLImageTypes {
  src: string;
  alt: string;
  sx?: SxProps;
}

const StyledImage = styled("img")(() => ({
  width: "inherit",
  height: "inherit",
}));

export const Image: FC<ImageProps> = (props) => {
  const { src, alt, sx, ...otherProps } = props;
  return (
    <Box sx={sx}>
      <StyledImage src={src} alt={alt} {...otherProps} />
    </Box>
  );
};
